<template>
  <footer
    v-if="$auth.isAuthenticated.value"
    class="bg-white text-center text-black border-t mt-16"
  >
    <div class="container mx-auto p-6">
      <ul class="flex mb-6">
        <li>
          <a
            class=""
            href="#"
            onclick="Osano.cm.showDrawer('osano-cm-dom-info-dialog-open')"
            >Manage Cookies</a
          >
        </li>
        <li>
          <a
            class="px-2"
            href="https://www.oliverwyman.com/content/dam/oliver-wyman/v2/legal/OW-General-Web-Portal-ToU.pdf"
            target="_blank"
          >
            Terms Of Use
          </a>
        </li>
        <li>
          <a
            class="px-2"
            href="https://www.oliverwyman.com/policies/privacy-notice-platforms.html"
            target="_blank"
          >
            Privacy Notice
          </a>
        </li>
        <li>
          <a
            class="px-2"
            href="https://www.oliverwyman.com/terms-of-use/statement-on-accessibility.html"
            target="_blank"
          >
            Statement On Accessibility
          </a>
        </li>
        <li>
          <a
            class="px-2"
            href="https://www.oliverwyman.com/policies/cookie-notice.html"
            target="_blank"
          >
            Cookie Notice
          </a>
        </li>
      </ul>

      <p className="text-left justify-left mb-4">
        © {{ formatCurrentYear() }} Oliver Wyman Inc. All Rights Reserved.
      </p>
    </div>
  </footer>
</template>

<script lang="ts">
export default {
  name: 'Footer',
  setup() {
    const formatCurrentYear = () => {
      const currentYear = new Date().getFullYear();
      return `${currentYear}`;
    };

    return {
      formatCurrentYear,
    };
  },
};
</script>
